import Main from './Main'

export default [
  { path: 'usuarios', component: Main, name: 'usuarios.main' }
]
